import { FormControl, InputAdornment, TextField, Typography } from '@mui/material';
import '../../../../../../scss/pages/Attendance/Component/Asset/Assets/SelectStore/selectStore.scss'
import React, { useEffect, useState } from 'react';
import LeftArrow from '../../../../../../asset/svg/leftArrow.svg';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import requestEmptyIcon from '../../../../../../asset/svg/requestEmptyIcon.svg';
import { useNavigate } from 'react-router';
import { ADMIN_PATH, ASSETS_REGISTER_PATH } from '../../../../../../utils/Constants';
import { GET_REGISTER_ASSET_STORE_DATA, HIDE_MODAL_SELECT_ITEM, HIDE_MODAL_SELECT_STORE, SELECT_STORE_DATA, SHOW_MODAL_ASSETGROUP } from '../../../../../../sagas/type';
import { getLocalStoreString, setLocalStoreString } from '../../../../../../utils/Helper';


function SelectStore() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    // const { setSelectData } = props;
    const { RegisterAssetDataStore, EmployeeCode_ } = useSelector(mapStateToProps);
    const EmployeeCode = getLocalStoreString("EmployeeCode");
    const [searchName, setSearchName] = useState('');
    const handleSearch = (event) => {
        const { value } = event.target
        setSearchName(value)
    }
    const handleSelectStore = (storeData) => {
        const { name, code, address } = storeData;
        setLocalStoreString("storeName", name)
        setLocalStoreString("storeCode", code)
        // setSelectData((selectDatas) => ({ ...selectDatas, selectStore: name, selectStoreCode: code, address: address }));
        dispatch({ type: SELECT_STORE_DATA, payload: storeData })
        dispatch({ type: SHOW_MODAL_ASSETGROUP })
        navigate(ASSETS_REGISTER_PATH, { state: { storeData } })
        dispatch({ type: HIDE_MODAL_SELECT_ITEM })
    }

    const handleBack = () => {
        navigate(ADMIN_PATH)
    }

    useEffect(() => {
        if (EmployeeCode_) {
            dispatch({
                type: GET_REGISTER_ASSET_STORE_DATA,
                EmployeeCode: EmployeeCode_,
            })
        }
    }, [EmployeeCode_])


    return (
        <div className='SelectStore-Container'>
            <div className='SelectStore-Container_header'>
                <div>
                    {/* <img className='SelectStore-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp; */}
                    <span className='SelectStore-Container_header_content'>Select Store</span>
                </div>
            </div>
            <div className='SelectStore-Container_searchcontainer'>
                <FormControl sx={{ width: '270px', backgroundColor: 'rgba(255,255,255,0.18)', borderRadius: '12px', padding: 1 }}>
                    <TextField size="small" type='search' autoComplete='off' variant="outlined" placeholder='Search' onChange={handleSearch} value={searchName}
                        InputProps={{ startAdornment: (<InputAdornment position='start'>{searchName.length == 0 && <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} />}</InputAdornment>), }} />
                </FormControl>
            </div>

            {RegisterAssetDataStore?.length > 0 ? (RegisterAssetDataStore?.filter((element) => (element?.name?.toLowerCase().includes(searchName?.toLowerCase()) || element?.code?.toLowerCase().includes(searchName?.toLowerCase()))).map((storeData) => {
                return (
                    <div key={storeData?.id} className='SelectStore-Container_searchcontainer' onClick={() => handleSelectStore(storeData)}>
                        <Typography sx={{ color: '#FFF', fontWeight: 500, fontSize: '12px', lineHeight: '12px', padding: '10px 0px 0px 0px' }}>{storeData?.code}-{storeData?.name}</Typography>
                    </div>
                )
            })) :
                (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                            <img style={{ heigth: '54px', width: '68px' }} src={requestEmptyIcon} alt="" />
                        </div>
                        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                            <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No Store Yet</Typography>
                        </div>
                    </div>
                )
            }

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        RegisterAssetDataStore: state.attendanceConfig.RegisterAssetDataStore,
        EmployeeCode_: state.authConfig.EmployeeCode,
    }
}

export default SelectStore